import {useTranslation} from 'react-i18next';

import {Typography} from '@mui/material';

import {empionGreen} from '../../../../layouts/theme/EmpionColors';

export const ApplicantProfilePageHeader = () => {
  const {t} = useTranslation();

  return (
    <Typography variant='h2' paddingBottom={2} sx={{color: empionGreen[700], fontWeight: 700}}>
      {t('applicantProfile.title')}
    </Typography>
  );
};
